import { useMutation } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { IScrapePageResult } from "../../models/SellerHistory/SellerSoldHistory";

interface ScrapePageArgs {
  seller: string;
  page: number;
}

export default function useSellerHistoryScrape() {
  const { post } = useApiHelper();

  const scrapePage = useMutation({
    mutationFn: (args: ScrapePageArgs) =>
      post<IDefaultResponse<IScrapePageResult>, ScrapePageArgs>(
        `/sellerhistory/scrape`,
        args
      ).then((res) => res.data),
  });

  return {
    scrapePage,
  };
}
